<template>
    <div class="bar" :style="style" @click.prevent="$emit('clicked')"></div>
</template>
<script>
import { TweenLite, Expo } from 'gsap'
export default {
    props: {
        value: {
            type: Number,
            required: true
        },
        max: {
            type: Number,
            required: true
        },
        size: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            number: 0,
            tweenedNumber: 0
        }
    },
    watch: {
        number (newValue) {
            TweenLite.to(this.$data, (Math.random() * 1.5), { tweenedNumber: newValue, ease: Expo.easeInOut })
        },
        value (newValue) {
            this.number = newValue
        }
    },
    computed: {
        width () {
            return (this.tweenedNumber / this.max) * this.size
        },
        style () {
            return 'width: ' + this.width + 'px'
        }
    },
    mounted () {
        this.animate()
    },
    methods: {
        animate () {
            setTimeout(() => {
                this.number = this.value
            }, (Math.random() * 2000))
        }
    }
}
</script>